const _hsq = (window._hsq = window._hsq || []);

type UseTrackPageviewResponse = {
  setUser: (email: string) => void;
  sendPageView: (location: string) => void;
  enableTracking: () => void;
  disableTracking: () => void;
};

export function useTrackPageview(): UseTrackPageviewResponse {
  const sendPageView = (location: string) => {
    _hsq.push(["setPath", location]);
    _hsq.push(["trackPageView"]);
  };

  const enableTracking = () => {
    _hsq.push(["doNotTrack", { track: true }]);
  };

  const disableTracking = () => {
    _hsq.push(["doNotTrack"]);
  };

  const setUser = (email: string) => {
    _hsq.push(["identify", { email }]);
  };

  return { sendPageView, enableTracking, disableTracking, setUser };
}
